<template>
  <!-- 业务员订单列表 -->
  <div class="salesmanOrderList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['业务员管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          placeholder="支付状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="已支付" value="2"></el-option>
          <el-option label="未支付" value="1"></el-option>
        </el-select>
        <label class="label">类型：</label>
        <el-select
          placeholder="类型"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.type"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="未审核" value="1"></el-option>
          <el-option label="已审核" value="2"></el-option>
          <!-- <el-option label="已上传" value="3"></el-option> -->
          <el-option label="已出库" value="5"></el-option>
          <!-- <el-option label="已收货" value="7"></el-option> -->
        </el-select>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          style="width: 200px; margin-right: 5px"
          v-model="searchForm.start"
          placeholder="请选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          style="width: 200px; margin-right: 5px"
          v-model="searchForm.end"
          placeholder="请选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入业务员名称"
          v-model="searchForm.client"
        ></el-input>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入客户公司/订单编号/下单人姓名"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="订单编号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ywyName"
        label="业务员名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userId"
        label="客户编号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userErp"
        label="客户ERP编号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="客户名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payType"
        label="支付方式"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="订单状态"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="price"
        label="订单金额"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="time"
        label="下单时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="create"
        label="操作"
        width="120"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click="addDetail(scope.row.id)"
            style="padding: 2px 3px"
            plain
            >查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "salesmanOrderList",
  data() {
    return {
      /**表格数据 */
      //序号	机构	操作	业务员名称	单据编号	客户编号	客户名称	收货人
      //支付方式	支付状态	订单状态	优惠金额	实付金额	总金额	来源	下单日期
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        status: "99",
        type: "99",
        start: "",
        end: "",
        name: "",
        client: "",
      },
    };
  },
  mounted() {
    this.getTableData(1);
  },
  methods: {
    /**获取数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetYwyOrderList",
        status: this.searchForm.status,
        payStatus: this.searchForm.type,
        strWhere: this.searchForm.name,
        ywyName: this.searchForm.client,
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "proc_dkxd_orders"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "salesmanOrder/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage = res.recordCount;
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = (res.data || []).map((item) => ({
              id: item.DJBH, // 订单编号
              ywyName: item.ywyname, // 业务员名称
              userId: item.username, // 客户编号
              userErp: item.erp_dwbh, // 客户ERP编号
              userName: item.businessname, // 客户名称
              payType: item.fukuanfs, // 支付方式
              status: item.ZTMC, // 订单状态
              price: item.HSJE, // 订单金额
              time: item.rq, // 下单时间
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData(1);
    },
    // 订单详情查看
    addDetail(id) {
      let prams = encodeURIComponent(JSON.stringify({ id: id }));
      this.$router.push({
        path: "orderInfo",
        query: {
          row: prams,
        },
      });
    },
  },
};
</script>

<style scoped>
.salesmanOrderList {
  width: 100%;
  height: 100%;
}
</style>
